import { FloatButton, Tooltip } from "antd";
import { OFFSET_HEADER } from "@/constant";

const FloatFooter = () => {
  return (
    <FloatButton.Group shape="circle" style={{ right: 24 }}>
      <Tooltip title="返回顶部" placement="left">
        <FloatButton.BackTop visibilityHeight={OFFSET_HEADER} />
      </Tooltip>
    </FloatButton.Group>
  );
};

export default FloatFooter;
